import { ref } from '@vue/composition-api'
import  store  from '@/store'

export default function landfillStore() {

  const loading = ref(false)
  const errors = ref({})

  const blank_data = {
    type: 'landfill',
    name: '',
    camp_id: null,
    device_id: null,
    camp_leave: '',
    camp_back: '',
    landfills: [{
      id: 1,
      area: null,
      count: null
    }],
    areas: [{
      id: 1,
      area: null,
      count: null
    }],
  }

  const form = ref(Object.assign({}, blank_data))

  const fetchPlan = id => {

    loading.value = true
    store.dispatch('plans/fetchPlan', id).then(r => {
      Object.assign(form.value, r.data.plan, {
        areas: r.data.plan.data.areas,
        landfills: r.data.plan.data.landfills
      })
      delete form.value.data
    }).finally(() => loading.value = false)
  }

  const submit = () => new Promise((resolve, reject) => {

     loading.value = true
     errors.value = {}

      store.dispatch('plans/createPlan', form.value)
        .then(r => {
          Object.assign(form.value, blank_data, {
            areas: [{ id: 1, area: null, count: null }],
            landfills: [{ id: 1, area: null, count: null }],
          })
          resolve(true)
        }).catch(reason => {
          if (reason.response.status === 422)
            errors.value = reason.response.data.errors
        reject(reason.response.data.message)
      }).finally(() => loading.value = false)

    })




  const update = () => new Promise((resolve, reject) => {
    loading.value = true
    errors.value = {}

    store.dispatch('plans/updatePlan', form.value).then(r => resolve(true))
      .catch(reason => {
        if (reason.response.status === 422)
          errors.value = reason.response.data.errors
        reject(reason.response.data.message)
      })
      .finally(() => loading.value = false)
  })


  return {
    loading,
    errors,
    form,
    submit,update,
    fetchPlan
  }
}
